import Base from 'netxcore@netx/core-app/views/appModalView';

import '../css/appModal.less';

import {faTimes} from '@fortawesome/pro-solid-svg-icons';
const icons = Base.initializeIcons({
	faTimes,
});

export default class AppModalView extends Base {
	/** @override */
	constructor(opts = {}) {
		opts.icons = {...icons, ...opts.icons};
		super(opts);
	}
}
